
  import * as storyblokRuntime$ee4oN6fo0KAK0lcQZqQDwafSxClc3K1TnLeoaoXpnAc from '/app/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as defaultRuntime$LhLk_45p6yqScjb1HK_vaTJ6mnWfl7_45m7i5Gw1Plfp7VI from '/app/apps/ags/providers/default/index.ts'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1440,
    "3xl": 1680,
    "4xl": 1920
  },
  "presets": {},
  "provider": "default",
  "domains": [
    "a.storyblok.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['storyblok']: { provider: storyblokRuntime$ee4oN6fo0KAK0lcQZqQDwafSxClc3K1TnLeoaoXpnAc, defaults: {"baseURL":"https://a.storyblok.com","modifiers":{"quality":"85"}} },
  ['default']: { provider: defaultRuntime$LhLk_45p6yqScjb1HK_vaTJ6mnWfl7_45m7i5Gw1Plfp7VI, defaults: {"baseURL":""} }
    }
  }
